/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
import type { Article } from './Article'
import { ArticleFromJSON, ArticleFromJSONTyped, ArticleToJSON } from './Article'
import type { ContentInner } from './ContentInner'
import {
  ContentInnerFromJSON,
  ContentInnerFromJSONTyped,
  ContentInnerToJSON,
} from './ContentInner'
import type { RecommendedService } from './RecommendedService'
import {
  RecommendedServiceFromJSON,
  RecommendedServiceFromJSONTyped,
  RecommendedServiceToJSON,
} from './RecommendedService'
import type { ServiceItemBreadcrumbsInner } from './ServiceItemBreadcrumbsInner'
import {
  ServiceItemBreadcrumbsInnerFromJSON,
  ServiceItemBreadcrumbsInnerFromJSONTyped,
  ServiceItemBreadcrumbsInnerToJSON,
} from './ServiceItemBreadcrumbsInner'

/**
 *
 * @export
 * @interface ServiceItem
 */
export interface ServiceItem {
  /**
   *
   * @type {string}
   * @memberof ServiceItem
   */
  title: string
  /**
   *
   * @type {string}
   * @memberof ServiceItem
   */
  slug: string
  /**
   *
   * @type {string}
   * @memberof ServiceItem
   */
  fullSlug: string
  /**
   *
   * @type {Array<ContentInner>}
   * @memberof ServiceItem
   */
  constructor: Array<ContentInner>
  /**
   *
   * @type {Array<ServiceItemBreadcrumbsInner>}
   * @memberof ServiceItem
   */
  breadcrumbs: Array<ServiceItemBreadcrumbsInner>
  /**
   *
   * @type {Date}
   * @memberof ServiceItem
   */
  publishedAt: Date
  /**
   *
   * @type {Array<RecommendedService>}
   * @memberof ServiceItem
   */
  recommendedServices?: Array<RecommendedService>
  /**
   *
   * @type {Array<Article>}
   * @memberof ServiceItem
   */
  recommendedBlogPosts?: Array<Article>
}

/**
 * Check if a given object implements the ServiceItem interface.
 */
export function instanceOfServiceItem(value: object): value is ServiceItem {
  if (!('title' in value) || value['title'] === undefined) return false
  if (!('slug' in value) || value['slug'] === undefined) return false
  if (!('fullSlug' in value) || value['fullSlug'] === undefined) return false
  if (!('constructor' in value) || value['constructor'] === undefined)
    return false
  if (!('breadcrumbs' in value) || value['breadcrumbs'] === undefined)
    return false
  if (!('publishedAt' in value) || value['publishedAt'] === undefined)
    return false
  return true
}

export function ServiceItemFromJSON(json: any): ServiceItem {
  return ServiceItemFromJSONTyped(json, false)
}

export function ServiceItemFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): ServiceItem {
  if (json == null) {
    return json
  }
  return {
    title: json['title'],
    slug: json['slug'],
    fullSlug: json['fullSlug'],
    constructor: (json['constructor'] as Array<any>).map(ContentInnerFromJSON),
    breadcrumbs: (json['breadcrumbs'] as Array<any>).map(
      ServiceItemBreadcrumbsInnerFromJSON
    ),
    publishedAt: new Date(json['publishedAt']),
    recommendedServices:
      json['recommendedServices'] == null
        ? undefined
        : (json['recommendedServices'] as Array<any>).map(
            RecommendedServiceFromJSON
          ),
    recommendedBlogPosts:
      json['recommendedBlogPosts'] == null
        ? undefined
        : (json['recommendedBlogPosts'] as Array<any>).map(ArticleFromJSON),
  }
}

export function ServiceItemToJSON(value?: ServiceItem | null): any {
  if (value == null) {
    return value
  }
  return {
    title: value['title'],
    slug: value['slug'],
    fullSlug: value['fullSlug'],
    constructor: (value['constructor'] as Array<any>).map(ContentInnerToJSON),
    breadcrumbs: (value['breadcrumbs'] as Array<any>).map(
      ServiceItemBreadcrumbsInnerToJSON
    ),
    publishedAt: value['publishedAt'].toISOString(),
    recommendedServices:
      value['recommendedServices'] == null
        ? undefined
        : (value['recommendedServices'] as Array<any>).map(
            RecommendedServiceToJSON
          ),
    recommendedBlogPosts:
      value['recommendedBlogPosts'] == null
        ? undefined
        : (value['recommendedBlogPosts'] as Array<any>).map(ArticleToJSON),
  }
}
